package fr.frux.shared.domain.model

/**
 * Une ligne de l'historique public d'un arbre. Les chaînes ([kind], [field], [source]) restent
 * celles du contrat et ne sont pas interprétées ici : une valeur inconnue ne doit jamais casser
 * la lecture. [field] est nul sur la ligne de création.
 */
data class TreeRevision(
    val kind: String,
    val field: String?,
    val before: Map<String, String>,
    val after: Map<String, String>,
    val authorName: String?,
    val reason: String?,
    val source: String,
    val redacted: Boolean,
    val atMillis: Long,
)

/** Historique de la plus récente à la plus ancienne. [truncated] : plus de corrections que la page. */
data class TreeRevisionLog(
    val revisions: List<TreeRevision>,
    val truncated: Boolean,
)

/**
 * Correction acceptée par le serveur. [undo] est l'inverse proposé par « Annuler », nul quand la
 * correction était elle-même une annulation.
 */
data class AppliedCorrection(
    val treeId: Long,
    val tree: Tree,
    val undo: TreeCorrection?,
)
